import script from "./RestaurantLayoutBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./RestaurantLayoutBase.vue?vue&type=script&setup=true&lang=ts"

import "./RestaurantLayoutBase.vue?vue&type=style&index=0&id=7cd05b03&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd05b03"]])

export default __exports__